import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { adminApiClient } from "../../lib/adminApiClient";
import { queryKeys } from "../../lib/queryClient";
import { ErrorBanner, LoadingState } from "../../components/States";
import { formatDateTime } from "../../lib/format";

export function AdminAuditLogPage() {
  const [actionFilter, setActionFilter] = useState("");
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.adminAuditEvents(actionFilter),
    queryFn: () => adminApiClient.listAuditEvents({ limit: 50, action: actionFilter || undefined }),
  });

  return (
    <div className="stack">
      <h1>Audit log</h1>
      <div className="field" style={{ maxWidth: 320 }}>
        <label htmlFor="action-filter">Filter by action</label>
        <input
          id="action-filter"
          type="text"
          placeholder="e.g. ADMIN_SUSPEND_LISTING"
          value={actionFilter}
          onChange={(e) => setActionFilter(e.target.value)}
        />
      </div>

      {isLoading && <LoadingState label="Loading audit log…" />}
      {isError && <ErrorBanner error={error} onRetry={() => void refetch()} />}

      {data && (
        <div style={{ overflowX: "auto" }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Action</th>
                <th>Actor</th>
                <th>Order</th>
                <th>Metadata</th>
                <th>When</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((e) => (
                <tr key={e.id}>
                  <td className="mono text-sm">{e.action}</td>
                  <td>{e.actorUsername ?? (e.actorId ? e.actorId.slice(0, 8) : "system")}</td>
                  <td className="mono text-sm">{e.orderId?.slice(0, 8) ?? "—"}</td>
                  <td className="mono text-sm" style={{ maxWidth: 320, wordBreak: "break-all" }}>
                    {e.metadata ? JSON.stringify(e.metadata) : "—"}
                  </td>
                  <td>{formatDateTime(e.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {data.items.length === 0 && <p className="muted">No audit events found.</p>}
        </div>
      )}
    </div>
  );
}
